export const contact = {
	contact: {
		title: 'Contact',
	},
	address: {
		title: 'Address',
	},
};
